import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectTextBottom12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconMediaObjectTextBottom12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.5 10.5a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h4a.5.5 0 0 1 .5.5m1.5-2a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1 0-1h7a.5.5 0 0 1 .5.5M9.5 6h-7a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5m1.5-.5A1.5 1.5 0 0 1 9.5 7h-7A1.5 1.5 0 0 1 1 5.5v-3A1.5 1.5 0 0 1 2.5 1h7A1.5 1.5 0 0 1 11 2.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectTextBottom12);
